import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { CreateExternalProviderBatchRequestBody } from "@shared-kernel/application/ports/student/student-repository";

export const createExternalProviderBatchRequest = createAsyncThunk<
  string,
  CreateExternalProviderBatchRequestBody,
  { extra: Partial<Dependencies> }
>(
  "externalProviderBatchRequest/createExternalProviderBatchRequest",
  async (body: CreateExternalProviderBatchRequestBody, { extra: { studentRepository } }) => {
    return studentRepository!.createExternalProviderBatchRequest(body);
  },
);

export const resetCreateExternalProviderBatchRequest = createAction("externalProviderBatchRequest/resetCreateExternalProviderBatchRequest");
